var React = require('react');

function BatteryHalf (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M616 160h-8v-16a48 48 0 0 0-48-48H48a48 48 0 0 0-48 48v224a48 48 0 0 0 48 48h512a48 48 0 0 0 48-48v-16h8a24 24 0 0 0 24-24V184a24 24 0 0 0-24-24zm-40 128h-32v64H64V160h480v64h32z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M320 320H96V192h224z","className":"fa-primary","key":2})]);
}

BatteryHalf.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = BatteryHalf;

BatteryHalf.default = BatteryHalf;
